import React, { createRef, useEffect, useState } from 'react';
import './index.css';
import { Col, InputNumber, Row, Slider, } from 'antd';
import styled from 'styled-components';
import { COLOR } from 'constants/colors';
import type { SliderMarks } from 'antd/es/slider';
import { CommonStyledComponentProps } from '__utils/type';
import { useMediaQuery } from 'react-responsive';

type OptionProps = {
    min: number,
    max: number,
    handleSliderChange: Function,
    defaultValue?: number,
    sliderLabel: string,
    addOn: React.ReactNode,
    marks: SliderMarks
}

interface SliderProps {
    options: OptionProps
}

const SliderCont = styled.div<CommonStyledComponentProps>`
    .ant-slider{
        margin: 10px 0 28px;
    }
    .ant-slider-handle{
        width: 24px;
        height: 24px;
        margin-top: -10px;
        background-color: ${COLOR.WHITE};
        border: solid 7px ${COLOR.GREEN};
        &:focus{
            border-color: ${COLOR.GREEN};
            box-shadow: 0 0 0 5px rgba(0, 164, 101, 12%);
        }
        .ant-tooltip-open {
            border-color: ${COLOR.GREEN};
        }
        .ant-slider:hover .ant-slider-handle:not(.ant-tooltip-open) {
            border-color: ${COLOR.GREEN};
        }
    }
    .ant-slider-track {
        height: 2px;
        background-color: ${COLOR.GREEN};
    }
    .ant-slider-rail {
        height: 1px;
    }
    .ant-slider:hover .ant-slider-track {
        background-color: ${COLOR.GREEN};
    }
    .ant-slider:hover .ant-slider-handle:not(.ant-tooltip-open) {
        border-color: ${COLOR.GREEN};
    }
    .ant-slider .ant-slider-rail{
        background-color: black;
    }
    .ant-input-number-input{
        text-align: right;
        font-size: ${props => props?.isMobile ? '16px' : '18px'};
        height: 36px;
    }
    .ant-input-number{
        border: none;
        border-bottom: 1px solid #d9d9d9;
       
    }
    .ant-input-number{
        input{
            &:focus{
                background-color: transparent !important;
            }
        }
    }
    .ant-input-number-group-addon{
        border: none;
        border-bottom: 1px solid #d9d9d9;
        color: ${COLOR.LABEL_GREY};
        background-color: transparent;
        padding: 0;
    } 
    .ant-slider-dot{
        display: none;
    } 
    .ant-slider-mark-text{
        transform: unset !important;
        color: ${COLOR.LABEL_GREY} !important;

    }
    .ant-input-number-group-wrapper{
        margin: 0px !important;
    }
    .ant-input-number-group-addon{
        font-size: ${props => props?.isMobile ? '16px' : '18px'};

    }
   
`;

const IntegerStep: React.FC<OptionProps> = ({ min, max, handleSliderChange, defaultValue, sliderLabel, addOn, marks, }) => {
    const [inputValue, setInputValue] = useState<any>();

    const onChange = (newValue: number) => {
        if (!newValue) {
            setInputValue(min);
            handleSliderChange(min);
        }
        else {
            setInputValue(newValue);
            handleSliderChange(newValue);
        }

    };

    useEffect(() => {
        defaultValue && onChange(defaultValue);
    }, [defaultValue]);
    const remoteInput = createRef<HTMLInputElement>()

    return (
        <>
            <Row justify='space-between' align='middle'>
                <Col xs={18} md={19}>
                    <p className='font14 grey1 bold'>{sliderLabel}</p>
                </Col>
                <Col xs={6} md={5}>
                    <InputNumber
                        ref={remoteInput}

                        id="sliderval"
                        min={min}
                        max={max}
                        style={{ margin: '0 16px' }}
                        value={inputValue}
                        onChange={onChange}
                        onKeyDown={(event: any) => {
                            const re = /^[0-9\b]+$/;
                            if (!re.test(event.key) && event.key !== 'Backspace') {
                                event.preventDefault();
                            }

                        }}
                        onKeyUp={
                            (event: any) => {
                                if (+event.target.value > max) {
                                    remoteInput.current?.blur()
                                }
                            }
                        }

                        addonAfter={addOn}
                        bordered={false}
                        controls={false}
                    />
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <Slider
                        min={min}
                        max={max}
                        onChange={onChange}
                        value={inputValue}
                        marks={marks}
                    />
                </Col>
            </Row>
        </>
    );
};


const SliderCustom: React.FC<SliderProps> = ({ options }: SliderProps) => {
    const isMobile = useMediaQuery({ maxWidth: 767 })
    return <SliderCont className='slider-container' isMobile={isMobile}>
        <IntegerStep {...options} />
    </SliderCont>

};

export default SliderCustom;